var _g, _defs;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgEnvelope(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 138,
    height: 145,
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#Envelope_svg__clip0_89_1619)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M1.02 58.99a4 4 0 013.97-3.954l125.367-.913a4 4 0 014.026 3.836l3.379 82.473a4 4 0 01-4.033 4.164L4.063 143.392a4 4 0 01-3.962-4.045L1.02 58.99z",
    fill: "#E8505B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M1.064 57.065L66.142 4.414a4 4 0 015.052.016l63.03 51.665",
    fill: "#E8505B"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M.055 143.355c-.17-.16 10.49-11.8 23.81-25.99 13.32-14.2 24.25-25.59 24.41-25.43.17.16-10.49 11.79-23.81 26-13.31 14.19-24.24 25.57-24.41 25.42zM137.935 144.635c-.17.15-10.55-11.25-23.19-25.47-12.64-14.22-22.74-25.87-22.57-26.02.17-.15 10.55 11.25 23.19 25.47 12.63 14.22 22.74 25.87 22.57 26.02z",
    fill: "#fff"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M9.295 61.209a4 4 0 01-1.53-3.126l-.16-32.885a4 4 0 013.901-4.019l108.722-2.657a4 4 0 014.096 3.88l1.091 36.394a3.998 3.998 0 01-1.516 3.256l-54.07 42.805a4.001 4.001 0 01-4.954.01L9.294 61.209z",
    fill: "#EEE"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M49.205 67.915l4.85-5.94 11.34 8.19 18.43-21.73 5.56 4.89-23.7 27.32-16.48-12.73z",
    fill: "#E8505B"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "Envelope_svg__clip0_89_1619"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#fff",
    transform: "translate(.055 .365)",
    d: "M0 0h137.89v144.27H0z"
  })))));
}

export default SvgEnvelope;